module.exports = __webpack_public_path__ + "static/media/capo.035ef5d6.jpg";